import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics, initAnalyticsWithRemoteConfig } from '@/lib/analytics';

export default function AnalyticsRouteTracker() {
  const location = useLocation();
  const initializedRef = useRef(false);
  const lastTrackedPathRef = useRef<string | null>(null);

  useEffect(() => {
    let mounted = true;

    initAnalyticsWithRemoteConfig().finally(() => {
      if (!mounted) return;
      initializedRef.current = true;
      const path = `${location.pathname}${location.search}`;
      lastTrackedPathRef.current = path;
      analytics.pageView(path);
    });

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (!initializedRef.current) return;
    const path = `${location.pathname}${location.search}`;
    if (lastTrackedPathRef.current === path) return;
    lastTrackedPathRef.current = path;
    analytics.pageView(path);
  }, [location.pathname, location.search]);

  return null;
}
